import { render, staticRenderFns } from "./WithholdingOptionsByStatus.vue?vue&type=template&id=c70f14ca&scoped=true"
import script from "./WithholdingOptionsByStatus.vue?vue&type=script&lang=js"
export * from "./WithholdingOptionsByStatus.vue?vue&type=script&lang=js"
import style0 from "./WithholdingOptionsByStatus.vue?vue&type=style&index=0&id=c70f14ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70f14ca",
  null
  
)

export default component.exports